import React from "react";
import {ActionResult, Avatar, Challenge} from "../../../schema";
import SessionActionDisplay from "./SessionActionDisplay";
import AvatarIcon from "../../AvatarIcon";
import classes from "./SessionAvatarResponseDisplay.module.css";

type props = React.ComponentProps<"div"> & {
  result: ActionResult;
  challenge: Pick<Challenge, "avatar">;
};

const SessionAvatarResponseDisplay = function ({result, challenge, className, ...props}: props) {
  return (
    <SessionActionDisplay
      variant="avatar"
      icon={<AvatarIcon adaptive avatar={challenge.avatar as Avatar} />}
      className={className}
      {...props}
    >
      <div className={classes.responsesContainer}>
        <div className={classes.response}>{result.response}</div>
      </div>
    </SessionActionDisplay>
  );
};

export default SessionAvatarResponseDisplay;
